











































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import Heading from '@/shared/components/Heading/Heading.vue';
import Earlyrenewal from '@/shared/components/EarlyRenewal/EarlyRenewal.vue';
import Alert from '@/shared/components/Alert/Alert.vue';
import AlertErrors from '@/shared/components/AlertErrors/AlertErrors.vue';
import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';
import FullTemplate from '@/shared/components/Template/Full.vue';
import CustomTemplate from '@/shared/components/Template/Custom.vue';
import CompleteRegisterModal from '@/app/features/Customer/features/CompleteRegister/CompleteRegisterModal.vue';
import CompleteRegisterModalMobile from '@/app/features/Customer/features/CompleteRegister/CompleteRegisterModalMobile.vue';
import CheckoutLoading from './CheckoutLoading.vue';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');
const CustomerModule = namespace('App/Customer');
const BehaviorModule = namespace('App/Behavior');

@Component({
  components: {
    Earlyrenewal,
    Heading,
    ScreenSizeVisibility,
    Alert,
    AlertErrors,
    FullTemplate,
    CustomTemplate,
    CompleteRegisterModal,
    CompleteRegisterModalMobile,
    CheckoutLoading,
  }
})
export default class Checkout extends Vue {
  @CheckoutModule.Getter('isRenewal')
  private isRenewal: boolean;

  @CheckoutModule.Getter('renewalMessage')
  private renewalMessage: string;

  @CheckoutModule.Getter
  private customTemplateGuid: string;

  @CustomerModule.State
  private registerIsIncomplete: boolean;

  @CustomerModule.Mutation
  private setRegisterIsIncomplete: Function;

  @CustomerModule.Getter('isLogged')
  private customerIsLogged: boolean;

  @AppModule.State
  private isPageLoading: boolean;

  private get templateWrapper () {
    return this.customTemplateGuid
      ? 'CustomTemplate'
      : 'FullTemplate';
  }

  private get hideLeftSide() {
    return this.customTemplateGuid && !this.customerIsLogged;
  }
}
